import React, { Fragment } from "react";

import blue from "../assets/img/blue.png";
import black from "../assets/img/black.png";
import green from "../assets/img/green.png";
import red from "../assets/img/red.png";
import orange from "../assets/img/orange.png";

const ProductImages = () => {
  return (
    <Fragment>
      <img src={blue} alt="blue ape" className="shoe show" color="blue" />
      <img src={red} alt="red ape" className="shoe" color="red" />
      <img src={green} alt="green ape" className="shoe" color="green" />
      <img src={orange} alt="orange ape" className="shoe" color="orange" />
      <img src={black} alt="black ape" className="shoe " color="black" />
    </Fragment>
  );
};

export default ProductImages;
